import { doc, getDoc, setDoc } from "firebase/firestore";
import { SiteSettings } from "../model/SiteSettingModel";
import { db } from "../firebaseConfig";

export const SettingGateway = {
    GetSettings: async () => {
        const docRef = doc(db, "website", "settings");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data() as SiteSettings;
        }

        return null;
    },
    UpdateSettings: async (settings: SiteSettings) => {

        settings = { ...settings };
        await setDoc(doc(db, "website", "settings"), settings);

        return settings;
    },
}